module.exports = __webpack_public_path__ + "static/media/iconDownloadMiro.ea106b22.svg";